module.exports = __webpack_public_path__ + "img/arrow-up.ae662433.svg";